import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const authErrorAtom = atom<string | null>({
  key: 'authErrorAtom',
  default: null,
  effects_UNSTABLE: [persistAtom],
});
